import { BehaviorSubject } from 'rxjs';
import { DataService } from '@app/services/data/data.service';
import { DirectusQuery } from '@app/interfaces/directus/directus-query.interface';
import { DirectusSchema } from '@app/interfaces/directus/directus-schema.interface';
import { Injectable } from '@angular/core';
import { Instruction } from '@app/models/instruction';

@Injectable({
    providedIn: 'root'
})
export class InstructionsService extends DataService {
    protected override collection: keyof DirectusSchema = 'instructions'; // default schema
    public override entities = new BehaviorSubject<Instruction[]>([]);
    protected override query: DirectusQuery = {
        deep: {},
        filter: {},
        fields: ['*'],
        limit: -1,
        sort: 'sort'
    };
}
